import styles from './SelectPerson.module.scss'
import { Button, Field } from '@/ui'
import { Field as FormikField } from 'formik'
import React, { useEffect, useState } from 'react'
import { connect } from 'formik'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Loader } from '@/components/Loader'
import { getValueByPath } from '@/utils/getValueByPath'

export const SelectPerson = connect(
	({
		formik: { setFieldValue, values, errors },
		iinFieldName,
		fullNameFieldName,
		iinLabel,
		fullNameLabel,
		onSelected = (values) => {},
		onChange = (value) => {},
		onSearch = (value) => {},
		isDisabled = false,
		isDisabledIinField = false,
		isRequired = true,
	}) => {
		const { t } = useTranslation()
		const [isLoading, setIsLoading] = useState(false)
		const iinValue = getValueByPath(values, iinFieldName)

		const { person, industryAgreement } = useSelector((state) => ({
			person: state.accidents.person,
			industryAgreement: state.industryAgreement.agreementByBin,
		}))

		useEffect(() => {
			if (!person.loading && !industryAgreement.loading) {
				setIsLoading(false)
			}
		}, [person.loading, industryAgreement.loading])

		const handleClick = () => {
			if (!iinValue || String(iinValue).length !== 12) return
			setIsLoading(true)
			let body = {
				onSuccess: (result) => {
					onSelected(result)
					setIsLoading(false)
				},
				onError: () => {
					setIsLoading(false)
				},
			}
			onSearch(body)
		}

		return (
			<div className={isDisabled ? styles.fieldAndButtonHardLevel : styles.fields}>
				<FormikField name={iinFieldName}>
					{({ field, meta: { touched, error } }) => (
						<Field
							{...field}
							type="number"
							hideNumberArrows
							isRequired={isRequired}
							label={iinLabel}
							placeholder={t('enter_count_digitals', { count: 12 })}
							error={(person.success || industryAgreement.success) && touched && error}
							maxLength={12}
							onChange={(value) => {
								field.onChange(value)
								onChange(value)
							}}
							disabled={isDisabledIinField || isDisabled}
						/>
					)}
				</FormikField>

				{!isDisabled ? (
					<div className={styles.button}>
						{isLoading ? (
							<Loader className={styles.loader} />
						) : (
							<Button
								type="button"
								buttonClassName={styles.selectButton}
								onClick={handleClick}
								disabled={isLoading || !iinValue || String(iinValue).length !== 12 || isDisabled}
							>
								{t('find')}
							</Button>
						)}
					</div>
				) : null}

				<FormikField name={fullNameFieldName}>
					{({ field, meta: { touched, error } }) => (
						<Field
							{...field}
							type="text"
							isRequired={isRequired}
							disabled
							label={fullNameLabel}
							error={touched && error}
							placeholder={t('auto_filled')}
							onChange
						/>
					)}
				</FormikField>
			</div>
		)
	}
)
